import { persist } from '@/assets/js/util.js'

const data = {
    id: null,
    master: false,
    email: '',
    name: '',
    tenant: null,
    // Least-privilege placeholder for the logged-out state. Real roles are set at
    // auth: self-signups are customers (customer-register hook), while staff/admin
    // come from admin invite links (invites hook). Never assume staff by default.
    role: 'customer',
    ageVerified: false,
    activeShiftSessionID: null
}

const context = persist('user', data)
export default context
